import React, { Component } from "react";
import { DatePicker, Select, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";

const { Option } = Select;

export default class AllergiesAndPrescriptionsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specific_allergies: "",
      current_prescriptions: [
        {
          id: 1,
          name: "",
          dose: "",
          frequency: "",
          frequency_type: "",
          date_started: "",
          reason: "",
          units: "",
          unit_type: "",
        },
      ],
      loading: false,
      email:"",
      neurostamp_id:"",
      modality_id:"",
      field_data:[],
      do_you_have_allergies:"",
      do_you_have_prescriptions:"",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.allergies_and_presriptions;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
       
        if (response.status == "1") {
          this.setState({
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            field_data: response.field_data.allergies_and_presriptions
          })
          for(let item of response.data){
            if(item.field=='DEMALLR'){
              this.setState({do_you_have_allergies: item.value })              
            }
            if(item.field=='DEMALLRG'){
              this.setState({specific_allergies: item.value })
            }
            if(item.field=='PRESCR'){
              this.setState({do_you_have_prescriptions: item.value })
            }
            if(item.field=='PRESCR_LIST'){
              let prescriptions=item.value ? JSON.parse(item.value): [
                {
                  id: 1,
                  name: "",
                  dose: "",
                  frequency: "",
                  frequency_type: "",
                  date_started: "",
                  reason: "",
                  units: "",
                  unit_type: "",
                },
              ] 
              let p_arr = [];
              for (let pitem of prescriptions) {
                if (pitem.date_started) {
                  pitem.date_started = dayjs(pitem.date_started);
                }
                p_arr.push(pitem);
              }
              this.setState({
                current_prescriptions: p_arr ? p_arr :[]
              })
            }
          }
          this.setState({
            loading:false
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {
    if (!this.state.do_you_have_allergies) {
      message.warning("Please select 'Do you have any allergies?' field");
      return;
    }
    if (this.state.do_you_have_allergies=='1') {
      if(!this.state.specific_allergies){
        message.warning("Please enter specific allergies.");
        return;
      }
    }
    if (!this.state.do_you_have_prescriptions) {
      message.warning("Please select 'Do you have any prescriptions?' field");
      return;
    }
    if(this.state.do_you_have_prescriptions==1){
      if (this.state.current_prescriptions.length==0) {
        message.warning("Please add at least one prescription.");
        return;
      }
      if (this.state.current_prescriptions.length > 0) {
        let list = this.state.current_prescriptions;
        for (let item of list) {
          if (!item.name) {
            message.warning("Please enter Prescription name");
            return;
          }
          if (!item.date_started) {
            message.warning("Please select Prescription Date started.");
            return;
          }
        }
      }
    }
    let questions=[]
    let list=this.state.field_data
    for(let item of list){
      if(item.field=='DEMALLR'){
        let obj={
          value:this.state.do_you_have_allergies,
          view_name:item.view_name,
          form:"Allergies and Prescriptions",
          field: item.field
        }
        questions.push(obj)            
      }
      if(item.field=='DEMALLRG'){
        let obj={
          value:this.state.specific_allergies,
          view_name:item.view_name,
          form:"Allergies and Prescriptions",
          field: item.field
        }
        questions.push(obj)  
      }
      if(item.field=='PRESCR'){
        let obj={
          value:this.state.do_you_have_prescriptions,
          view_name:item.view_name,
          form:"Allergies and Prescriptions",
          field: item.field
        }
        questions.push(obj) 
      }
      // if(item.field=='PRESCR_LIST'){
      // }
    }
    let obj={
      value:
      JSON.stringify(this.state.current_prescriptions),
      view_name:'v_EALSPE_DEMOGALS_7_nt',
      form:"Allergies and Prescriptions",
      field: 'PRESCR_LIST'
    }
    questions.push(obj) 
    const uniqueNames = [...new Map(questions.map(item => [item.field, item])).values()];
    let params = {
      data: JSON.stringify(uniqueNames),
      step: speech_demographics_form_type.allergies_and_presriptions,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(7);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  add_new_prescription = () => {
    let arr = this.state.current_prescriptions;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
      dose: "",
      frequency: "",
      frequency_type: "",
      date_started: "",
      reason: "",
      units: "",
      unit_type: "",
    };
    arr.push(obj);
    this.setState({ current_prescriptions: arr });
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  remove_prescription = (id) => {
    let arr = this.state.current_prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ current_prescriptions: tempArr });
  };
  update_prescription = (event, item, field) => {
    let arr = this.state.current_prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "name") {
          single.name = event.target.value;
        }
        if (field == "dose") {
          single.dose = event.target.value;
        }
        if (field == "units") {
          single.units = event.target.value;
        }
        if (field == "unit_type") {
          single.unit_type = event.target.value;
        }
        if (field == "frequency") {
          single.frequency = event.target.value;
        }
        if (field == "frequency_type") {
          single.frequency_type = event.target.value;
        }
        if (field == "date_started") {
          single.date_started = event;
        }
        if (field == "reason") {
          single.reason = event.target.value;
        }
      }
      tempArr.push(single);
    }
    this.setState({ current_prescriptions: tempArr });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Allergies and Prescriptions</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any allergies?&nbsp;
                  <span className="text-danger">*</span>
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_allergies: event.target.value,
                    specific_allergies:""
                  })
                }
                value={this.state.do_you_have_allergies}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"1"}>Yes</Radio>
                  <Radio value={"2"}>No</Radio>
                </Space>
              </Radio.Group>
              <br/>
              {this.state.do_you_have_allergies=='1' && (
                <div className="col-lg-12 mt-3">
                 <label className="mb-2 input-heading">
                   Please, list specific allergies
                   <span className="text-danger">*</span>
                 </label><br/>
                 <input
                   type={"text"}
                   value={this.state.specific_allergies}
                   onChange={(e) =>
                     this.setState({ specific_allergies: e.target.value })
                   }
                   placeholder="Please, list specific allergies"
                 />
               </div>
              )}
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any prescriptions?&nbsp;
                  <span className="text-danger">*</span>
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_prescriptions: event.target.value,
                    current_prescriptions:[]
                  })
                }
                value={this.state.do_you_have_prescriptions}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"1"}>Yes</Radio>
                  <Radio value={"2"}>No</Radio>
                </Space>
              </Radio.Group>
              <br/>
              {this.state.do_you_have_prescriptions=='1' && (
                <div className="col-lg-12 mt-3">
                <div className="d-flex justify-content-between col-lg-12">
                  <label className="mb-2 input-heading">
                   Please, list specific prescriptions
                   <span className="text-danger">*</span>
                  </label>
                   <button
                    className="add_row_button"
                    onClick={() => this.add_new_prescription()}
                  >
                    {" "}
                    <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                    &nbsp;&nbsp;Add{" "}
                  </button>
                </div>
                <br />
              <div className="col-lg-12">
                <table className="medical-history-table">
                  <tr>
                    <th style={{ width: 170 }}>
                      Medication<span className="text-danger">*</span>
                    </th>
                    <th style={{ width: 100 }}>Dose</th>
                    <th style={{ width: 80 }}>Units</th>
                    <th style={{ width: 60 }}>Frequency</th>
                    <th>
                      Start Date <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: 60 }}>Reason</th>
                    <th>Action</th>
                  </tr>
                  {this.state.current_prescriptions.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            type="text"
                            value={item.name}
                            style={{ height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "name")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.dose}
                            style={{ height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "dose")
                            }
                          />
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <input
                              type="text"
                              value={item.units}
                              style={{
                                width: 67,
                                height: 35,
                                marginRight: 6,
                                marginBottom: 4,
                              }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "units")
                              }
                            />
                            <select
                              value={item.unit_type}
                              onChange={(e) =>
                                this.update_prescription(e, item, "unit_type")
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="mg">Mg</option>
                              <option value="gm">Gm</option>
                              <option value="ug/mcg">Ug/mcg</option>
                              <option value="ml">mL</option>
                              <option value="units">Units</option>
                              <option value="tabs/caps">Tabs/Caps</option>
                              <option value="drop">Drop</option>
                              <option value="sprays">Sprays</option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <input
                              type="number"
                              min="0"
                              value={item.frequency}
                              style={{
                                height: 35,
                                width: 67,
                                marginRight: 6,
                                marginBottom: 4,
                              }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "frequency")
                              }
                            />
                            <select
                              value={item.frequency_type}
                              onChange={(e) =>
                                this.update_prescription(
                                  e,
                                  item,
                                  "frequency_type"
                                )
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="qd">qd</option>
                              <option value="bid">bid</option>
                              <option value="tid">tid</option>
                              <option value="qid">qid</option>
                              <option value="qod">qod</option>
                              <option value="prn">prn</option>
                              <option value="other">other</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <DatePicker
                            value={item.date_started}
                            onChange={(date, dateString) =>
                              this.update_prescription(
                                date,
                                item,
                                "date_started"
                              )
                            }
                            style={{
                              width: "100%",
                              height: 35,
                              maxWidth: 500,
                            }}
                            format={"MM/YYYY"}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.reason}
                            style={{ width: 80, height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "reason")
                            }
                          />
                        </td>
                        <td>
                          <center>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => this.remove_prescription(item.id)}
                            >
                              <box-icon
                                size={"20px"}
                                name="trash"
                                color="red"
                              ></box-icon>
                            </span>
                          </center>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
               </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{ padding: "9px 28px 10px 21px"}}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(5)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
